import { FC } from 'react';
import useLocales from '@hooks/useLocales';
import { Box, Button, Typography, useMediaQuery, useTheme } from '@mui/material';
import Image from '@components/Image';
import { useStyles } from './styles';
import { useRouter } from 'next/router';
import { useSignUpRedirect } from '~/hooks/useSignUpRedirect';
import useAuth from '~/hooks/useAuth';

const TopBlock: FC = () => {
  const { t } = useLocales();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const styles = useStyles(theme);
  const { isAuthenticated } = useAuth();
  const router = useRouter();
  const { signUpRedirect } = useSignUpRedirect();
  return (
    <Box width="100%" sx={styles.topBlockBox}>
      {isMobile ? (
        <Box sx={styles.topBlockContent}>
          {/* <SvgIconStyle src="/logo_small.png" sx={styles.topBlockLogo} /> */}
          <Box>
            {isAuthenticated ? (
              <Button
                variant="contained"
                size="medium"
                color="primary"
                sx={styles.getStartedButton}
                onClick={() => router.push('/loan-officers/dashboard')}
              >
                {t('landing.home')}
              </Button>
            ) : (
              <Button
                variant="contained"
                size="medium"
                color="primary"
                sx={styles.getStartedButton}
                onClick={() => router.push('/login')}
              >
                {t('landing.sign_in')}
              </Button>
            )}
            {/* <MobileDropdownContainer /> */}
          </Box>
        </Box>
      ) : (
        <Box sx={styles.topBlockContent}>
          {/* <SvgIconStyle src="/icons/ic_logo.svg" sx={styles.topBlockLogo} /> */}
          <Box>
            {/* <Button variant="text" size="medium" sx={styles.topBlockButton}>
              <Link href="/landing/#solutions" sx={styles.link}>
                {t('landing.solutions')}
              </Link>
            </Button>
            <Button variant="text" size="medium" sx={styles.topBlockButton}>
              <Link href="/landing/#about" sx={styles.link}>
                {t('landing.about')}
              </Link>
            </Button>
            <Button variant="text" size="medium" sx={styles.topBlockButton}>
              <Link href="/landing/#features" sx={styles.link}>
                {t('landing.features')}
              </Link>
            </Button>
            <Button variant="text" size="medium" sx={styles.topBlockButton}>
              <Link href="/landing/#testimonials" sx={styles.link}>
                {t('landing.testimonials')}
              </Link>
            </Button> */}
            {isAuthenticated ? (
              <Button
                variant="contained"
                size="medium"
                color="primary"
                onClick={() => router.push('/loan-officers/dashboard')}
              >
                {t('landing.home')}
              </Button>
            ) : (
              <Button
                variant="contained"
                size="medium"
                color="primary"
                onClick={() => router.push('/login')}
              >
                {t('landing.sign_in')}
              </Button>
            )}
          </Box>
        </Box>
      )}
      <Box sx={styles.topBlockTextBox}>
        <Image alt="logo" src="/logo/bpd_logo_w2.png" sx={styles.logo} />
        <Typography variant="h6" sx={styles.topBlockText}>
          {t('landing.topblock_text')}
        </Typography>
        <Button
          variant="contained"
          size="large"
          color="primary"
          sx={styles.topBlockButtonStart}
          onClick={signUpRedirect}
        >
          {t('landing.get_started')}
        </Button>
      </Box>
      {/* <Image
        alt="cover"
        src="/hand-presenting-model-house-home-loan-campaign.png"
        sx={styles.topBlockImage}
      /> */}
    </Box>
  );
};

export default TopBlock;
